export default __webpack_public_path__ + "static/media/discord_darkGray3.434e752f.svg";